import api from "APP_ROOT/api";
import * as actionTypes from "./actionTypes";
import pagination from "./pagination";

export const { pageActions: dashboardPageActions } = pagination;

export function show(id) {
  return dispatch =>
    api.companies.show(id).then(resp =>
      dispatch({
        type: actionTypes.SET,
        company: resp.data
      })
    );
}

export function getCompany(id) {
  return api.companies.show(id).then(resp => Promise.resolve(resp.data));
}

export function asyncVendorStatusLastVerified(company) {
  const serializedUser = JSON.parse(window.localStorage.getItem("user"));

  const data = {
    vendor_status_verified_details: {
      updated_at: new Date(),
      updated_by: {
        id: serializedUser.id,
        name: serializedUser.full_name
      }
    }
  };

  return dashboardPageActions.updateAsync(
    company.id,
    data,
    api.companies.vendorStatusLastVerified(company.id, data)
  );
}



// WEBPACK FOOTER //
// ./app/modules/ApprovedVendors/actions.js